module.exports = __webpack_public_path__ + "4f61e1bd2ff8351755c6f5ab26dbf3a0.pdf";